const articleForm = (Simplebar) => {
    const articleForms = document.querySelectorAll(".article-form");
    articleForms.forEach(item => {
        const itemScroll = item.querySelector(".article-form__scroll");
        if (itemScroll) new Simplebar(itemScroll, {
           autohide: false,
        })

        const itemForm = item.querySelector(".article-form__form");
        itemForm.addEventListener("submit", function(e){
            e.preventDefault();
            const recaptcha = this.querySelector(".g-recaptcha");
            if (recaptcha) {
                const recaptchaResponse = recaptcha.querySelector("textarea.g-recaptcha-response");
                if (!recaptchaResponse.value) {
                    recaptcha.classList.add("error");
                    return;
                }
                else {
                    recaptcha.classList.remove("error");
                }
            }
            item.classList.add("loading");
            fetch(this.action, {
                method: "POST",
                body: new FormData(this)
            })
                .then(res => res.json())
                .then(res => {
                    if (res.status === 200) {
                        item.querySelector(".article-form__succes-text").innerText = res.message;
                        item.classList.remove("loading");
                        item.classList.add("success");
                    }
                })
                .catch(err => {
                    console.log(err);
                    item.classList.remove("loading");
                    item.classList.remove("success");
                })
        })

        item.addEventListener("click", function(e){
            if (e.target.classList.contains("article-form__close") || e.target.classList.contains("article-form")) {
                this.classList.remove("open");
            }
        })
    });
    const formBtns = document.querySelectorAll(".project-views__item-text-btn, .order-drawings__btn");
    formBtns.forEach(item => {
        item.addEventListener("click", function(){
            if (this.dataset.hasOwnProperty("form")) {
                document.querySelector(this.dataset.form).classList.add("open");
            }
        });
    })
}

export default articleForm;
